export const APP_ROUTES = {
  app: {
    root: {
      path: '/',
      getHref: () => '/',
    },
  },

  csat: {
    path: 'csat-submission/:caseId',
    getHref: (caseId: string) => `/csat-submission/${caseId}`,

    successCSATPage: {
      path: 'success-csat',
      getHref: () => '/success-csat',
    },
  },

  auth: {
    signup: {
      path: '/signup',
      getHref: (redirectTo?: string | null | undefined) =>
        `/signup${redirectTo ? `?redirectTo=${encodeURIComponent(redirectTo)}` : ''}`,
    },

    login: {
      path: '/login',
      getHref: (redirectTo?: string | null | undefined) =>
        `/login${redirectTo ? `?redirectTo=${encodeURIComponent(redirectTo)}` : ''}`,
    },

    forgotPassword: {
      path: '/forgot-password',
      getHref: () => '/forgot-password',
    },

    acceptInvitation: {
      path: '/accept-invitation',
      getHref: () => '/accept-invitation',
    },

    memberInvitation: {
      path: '/member-invitation',
      getHref: () => '/member-invitation',
    },
  },

  cases: {
    activeCases: {
      path: 'active-cases',
      getHref: () => '/active-cases',
    },

    unassignedCases: {
      path: 'unassigned-cases',
      getHref: () => '/unassigned-cases',
    },

    closeCases: {
      path: 'close-cases',
      getHref: () => '/close-cases',
    },

    analytics: {
      path: 'analytics',
      getHref: () => '/analytics',
    },
  },

  customerManagement: {
    root: {
      path: 'customer-management',
      getHref: () => '/customer-management',
    },

    detailCustomer: {
      path: 'detail-customer/:customerId',
      getHref: (customerId: string) => `/customer-management/detail-customer/${customerId}`,
    },
  },

  channelIntegrations: {
    root: {
      path: 'channel-integrations',
      getHref: () => '/channel-integrations',
    },

    socialMedia: {
      root: {
        path: 'social-media',
        getHref: (tabActive?: string | null | undefined) =>
          `/channel-integrations/social-media${tabActive ? `?tabActive=${encodeURIComponent(tabActive)}` : ''}`,
      },
      addMeta: {
        path: 'add-meta',
        getHref: () => '/channel-integrations/social-media/add-meta',
      },

      addX: {
        path: 'add-x',
        getHref: () => '/channel-integrations/social-media/add-x',
      },

      addTiktok: {
        path: 'add-tiktok',
        getHref: () => '/channel-integrations/social-media/add-tiktok',
      },
      addThreads: {
        path: 'add-threads',
        getHref: () => '/channel-integrations/social-media/add-threads',
      },
    },

    chatPlatform: {
      root: {
        path: 'chat-platform',
        getHref: (tabActive?: string | null | undefined) =>
          `/channel-integrations/chat-platform${tabActive ? `?tabActive=${encodeURIComponent(tabActive)}` : ''}`,
      },
      addLine: {
        path: 'add-line',
        getHref: () => '/channel-integrations/chat-platform/add-line',
      },
      addWhatsapp: {
        path: 'add-whatsapp',
        getHref: () => '/channel-integrations/chat-platform/add-whatsapp',
      },
    },

    googleReview: {
      root: {
        path: 'google-review',
        getHref: () => '/channel-integrations/google-review',
      },
      addGoogleReview: {
        path: 'add-google-review',
        getHref: () => '/channel-integrations/google-review/add-google-review',
      },
    },

    googlePlayStore: {
      root: {
        path: 'google-play-store',
        getHref: () => '/channel-integrations/google-play-store',
      },
      addGooglePlayStore: {
        path: 'add-google-play-store',
        getHref: () => '/channel-integrations/google-play-store/add-google-play-store',
      },
    },

    appStore: {
      root: {
        path: 'app-store',
        getHref: () => '/channel-integrations/app-store',
      },
      addAppStore: {
        path: 'add-app-store',
        getHref: () => '/channel-integrations/app-store/add-app-store',
      },
    },

    email: {
      root: {
        path: 'email',
        getHref: () => '/channel-integrations/email',
      },

      addEmail: {
        path: 'add-email',
        getHref: () => '/channel-integrations/email/add-email',
      },
    },

    youtube: {
      root: {
        path: 'youtube',
        getHref: () => '/channel-integrations/youtube',
      },

      addYoutube: {
        path: 'add-youtube',
        getHref: () => '/channel-integrations/youtube/add-youtube',
      },
    },

    nolimiEngage: {
      root: {
        path: 'nolimit-engage',
        getHref: () => '/channel-integrations/nolimit-engage',
      },
      addNolimiEngage: {
        path: 'add-nolimit-engage',
        getHref: () => '/channel-integrations/nolimit-engage/add-nolimit-engage',
      },
    },
  },

  settings: {
    root: {
      path: 'settings',
      getHref: () => '/settings',
    },

    profile: {
      path: 'profile',
      getHref: () => '/settings/profile',
    },

    label: {
      path: 'label',
      getHref: () => '/settings/label',
    },

    customerSurvey: {
      root: {
        path: 'customer-survey',
        getHref: () => '/settings/customer-survey',
      },

      addCustomerSurvey: {
        path: 'add-customer-survey',
        getHref: () => '/settings/customer-survey/add-customer-survey',
      },

      editCustomerSurvey: {
        path: 'edit-customer-survey/:customerSurveyId',
        getHref: (customerSurveyId: string) => `/settings/customer-survey/edit-customer-survey/${customerSurveyId}`,
      },
    },

    manageAgent: {
      root: {
        path: 'manage-agent',
        getHref: () => '/settings/manage-agent',
      },
      detailAgent: {
        path: 'detail-agent/:agentId',
        getHref: (agentId: string) => `/settings/manage-agent/detail-agent/${agentId}`,
      },
      detailTeam: {
        path: 'detail-team/:teamId',
        getHref: (teamId: string) => `/settings/manage-agent/detail-team/${teamId}`,
      },
    },

    configurations: {
      path: 'configurations',
      getHref: () => '/settings/configurations',
    },

    notification: {
      path: 'notification',
      getHref: () => '/settings/notification',
    },

    ticketing: {
      path: 'ticketing',
      getHref: () => '/settings/ticketing',
    },

    replyTemplate: {
      path: 'reply-template',
      getHref: () => '/settings/reply-template',
    },
  },

  ticketing: {
    root: {
      path: 'ticketing',
      getHref: () => '/ticketing',
    },
  },

  error: {
    notFound: {
      path: '404',
      getHref: () => '/404',
    },
    forbidden: {
      path: '403',
      getHref: () => '/403',
    },
  },
};
